import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from 'components/App';
import * as serviceWorker from './serviceWorker';
import { tenantConfig } from 'config';
import { initGTM, trackPageView } from 'util/gtm';

import './index.scss';

initGTM();
trackPageView(window.location.pathname + window.location.hash);

// Init Sentry
if (tenantConfig.environment) {
  Sentry.init({
    dsn: tenantConfig.sentryDSN,
    environment: tenantConfig.environment,
    integrations: (integrations) => [
      ...integrations,
      Sentry.browserTracingIntegration(),
    ],
    
    tracesSampleRate: tenantConfig.environment === 'prd' ? 0.05 : 1.0,
  });
}

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
    <App />
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
